import React from 'react';
import { FileText, Settings, Award, Users, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

const AdminOverviewTab = ({ 
  statistics, 
  setActiveTab, 
  handleImportPreviewData, 
  importingData 
}) => {
  return (
    <>
      <div className="grid md:grid-cols-4 gap-6 mb-8">
        <div 
          className="card-gold p-6 cursor-pointer hover:shadow-lg hover:border-greek-blue/30 transition-all"
          onClick={() => setActiveTab('applications')}
          title="Click to view all applications"
        >
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-greek-blue/10 rounded-sm flex items-center justify-center">
              <FileText className="w-6 h-6 text-greek-blue" />
            </div>
            <div>
              <p className="text-3xl font-bold text-slate-900">{statistics?.applications?.total || 0}</p>
              <p className="text-sm text-slate-500">Total Applications</p>
            </div>
          </div>
        </div>
        <div 
          className="card-gold p-6 cursor-pointer hover:shadow-lg hover:border-amber-300 transition-all"
          onClick={() => setActiveTab('applications')}
          title="Click to view applications under review"
        >
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-amber-100 rounded-sm flex items-center justify-center">
              <Settings className="w-6 h-6 text-amber-600" />
            </div>
            <div>
              <p className="text-3xl font-bold text-slate-900">{statistics?.applications?.under_review || 0}</p>
              <p className="text-sm text-slate-500">Under Review</p>
            </div>
          </div>
        </div>
        <div 
          className="card-gold p-6 cursor-pointer hover:shadow-lg hover:border-emerald-300 transition-all"
          onClick={() => setActiveTab('applications')}
          title="Click to view awarded applications"
        >
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-emerald-100 rounded-sm flex items-center justify-center">
              <Award className="w-6 h-6 text-emerald-600" />
            </div>
            <div>
              <p className="text-3xl font-bold text-slate-900">{statistics?.applications?.awarded || 0}</p>
              <p className="text-sm text-slate-500">Awarded</p>
            </div>
          </div>
        </div>
        <div 
          className="card-gold p-6 cursor-pointer hover:shadow-lg hover:border-purple-300 transition-all"
          onDoubleClick={() => setActiveTab('users')}
          title="Double-click to manage users"
        >
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-purple-100 rounded-sm flex items-center justify-center">
              <Users className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <p className="text-3xl font-bold text-slate-900">{statistics?.users || 0}</p>
              <p className="text-sm text-slate-500">Total Users</p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div 
          className="bg-white rounded-sm border border-slate-200 p-6 cursor-pointer hover:shadow-lg hover:border-greek-gold/50 transition-all"
          onDoubleClick={() => setActiveTab('scholarships')}
          title="Double-click to view scholarships"
        >
          <h3 className="font-heading text-lg font-semibold text-slate-900 mb-4">Active Scholarships</h3>
          <p className="text-4xl font-bold text-greek-gold">{statistics?.scholarships?.active || 0}</p>
          <p className="text-slate-500">of {statistics?.scholarships?.total || 0} total</p>
        </div>
        <div 
          className="bg-white rounded-sm border border-slate-200 p-6 cursor-pointer hover:shadow-lg hover:border-greek-blue/50 transition-all"
          onDoubleClick={() => setActiveTab('scholarships')}
          title="Double-click to view submitted applications"
        >
          <h3 className="font-heading text-lg font-semibold text-slate-900 mb-4">Submitted Applications</h3>
          <p className="text-4xl font-bold text-greek-blue">{statistics?.applications?.submitted || 0}</p>
          <p className="text-slate-500">awaiting review</p>
        </div>
      </div>

      {/* Admin Tools Section */}
      <div className="mt-8 bg-white rounded-sm border border-slate-200 p-6">
        <h3 className="font-heading text-lg font-semibold text-slate-900 mb-4">Admin Tools</h3>
        <div className="flex items-center gap-4">
          <Button
            onClick={handleImportPreviewData}
            disabled={importingData}
            variant="outline"
            className="rounded-sm border-greek-blue/30 text-greek-blue hover:bg-greek-blue/5"
            data-testid="import-preview-data-btn"
          >
            <Download className="w-4 h-4 mr-2" />
            {importingData ? 'Importing...' : 'Import Preview Data'}
          </Button>
          <p className="text-sm text-slate-500">
            Import scholarships and committees from the preview environment to production
          </p>
        </div>
      </div>
    </>
  );
};

export default AdminOverviewTab;